import { useCallback, useEffect, useState } from "react";
import { mappingApi } from "@services/mappingApi";
import type { MappingServiceViewModel } from "@models/service";

export interface UseMappingServicesResult {
  services: MappingServiceViewModel[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export const useMappingServices = (): UseMappingServicesResult => {
  const [services, setServices] = useState<MappingServiceViewModel[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const refetch = useCallback(async (): Promise<void> => {
    setLoading(true);
    setError(null);
    try {
      const result = await mappingApi.listServices();
      setServices(result);
    } catch (err) {
      const message =
        err instanceof Error ? err.message : "Failed to load mapping services";
      setError(message);
      console.error("Error loading mapping services:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refetch();
  }, [refetch]);

  return { services, loading, error, refetch };
};
